import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { CiacService } from 'src/app/services/http/ciac.service';
import { ModalMsgService } from 'src/app/services/modal-msg.service';
import { ModalJustificativaComponent } from 'src/app/app-components/modal-justificativa/modal-justificativa.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-historico-dcs',
  templateUrl: './historico-dcs.component.html',
  styleUrls: ['./historico-dcs.component.scss']
})
export class HistoricoDcsComponent implements OnInit {

  @Input() idConsulta;
  @Input() loading;

  sorting: { 
    id: "asc",
  }

  filter = {
    sorting: { 
      id: "asc",
    },
    filter: {
      nome: "",
    },
    data: new Date(),
    page: 1,
    per_page: 10,
  };

  total:number = 0;
  listaDadosSaida = [];
  tableLoading = true;

  constructor(private ciacService: CiacService, private modalService: NgbModal, private modalMsgService: ModalMsgService) { }

  ngOnInit() {
    this.getListaDadosSaida();
    this.loading.subscribe(c => {
      if(c) {
        this.getListaDadosSaida();
      }
    });
  }

  getListaDadosSaida() {
    this.filter.sorting = this.removeEmpty({ ...this.sorting });
    let filtro = {
      ...this.filter,
      idConsulta: parseInt(this.idConsulta)
    }
    let dataUpdate = filtro.data;
    this.ciacService.getDcsConsulta(filtro).then(c => {
      if(dataUpdate == filtro.data) {
        this.tableLoading = false;
        this.total = c.total || 0;
        this.listaDadosSaida = c.lista || [];
      }
    });
    if(this.listaDadosSaida.length == 0) {
      this.tableLoading = false;
    }
  }

  removeEmpty(obj) {
    this.listaDadosSaida = [];
    Object.keys(obj).forEach((key) => (obj[key] == '') && delete obj[key]);
    return obj;
  }

  setPageSize(pageSize) {
    this.filter.page = 1;
    this.filter.per_page = pageSize;
    this.getListaDadosSaida();
  }

  nextPage() {
    this.getListaDadosSaida();
  }

  editDadoSaida(id) {
    this.ciacService.getHistoricoDadosSaida(id);
  }

  delDadoSaida(id) {
    let params = {
      id: parseInt(id)
    }
    const modalRef = this.modalService.open(ModalJustificativaComponent, { centered: true });
    modalRef.componentInstance.cabecalho = 'Remover dado saída';
    modalRef.result.then(justificativa => {
      if (justificativa) {
        this.ciacService.delDadosSaida(justificativa, params)
          .then(r => this.getListaDadosSaida())
          .catch(e => this.modalMsgService.openDialog('Erro ao remover dado saída', '', 'danger'));
      } else {
        this.modalMsgService.openDialog('Erro ao remover dado saída',
          'Informe uma Justificativa para concluir a operação', 'danger');
      }
    }).catch(e => this.modalMsgService.openDialog('Erro ao remover dado saída',
      'Informe uma Justificativa para concluir a operação', 'danger'));
  }

}
